// src/utils/sendEmail.ts

export interface EmailParams {
  to: string[];
  subject: string;
  html?: string;
  message?: string;
  text?: string;
  attachments?: Array<{ filename: string; content: string; type?: string }>;
}

/**
 * Sends an email using the MindTech API endpoint.
 * @param params Email parameters
 * @returns Promise<void>
 */
export async function sendEmail(params: EmailParams): Promise<void> {
  try {
    console.log('Sending email payload:', params);
    const response = await fetch('https://mtops-console-app.mindtechinc.com/api/email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // Log error for debugging but do not throw to block UI
      console.error('Email send failed:', errorData?.message || response.statusText || 'Failed to send email', params);
    }
  } catch (err: any) {
    // Log network or unexpected errors
    console.error('Email send error:', err?.message || err, params);
  }
}
